import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AuditLogsQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int']['input'];
  limit: Types.Scalars['Int']['input'];
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  numberOrActorFilter?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortBy?: Types.InputMaybe<Array<Types.AuditLogsSortBy>>;
}>;


export type AuditLogsQuery = { __typename?: 'Query', auditLogs: { __typename?: 'AuditLogList', totalCount: number, items: Array<{ __typename?: 'AuditLog', id: number, actor: string, category: Types.AuditLogCategory, change: string, timestamp: any, details: any, domain?: { __typename?: 'Domain', id: number, name: string } | null, number?: { __typename?: 'Number', id: number, shortNumber?: string | null, e164?: any | null } | null, relatedNumber?: { __typename?: 'Number', id: number, shortNumber?: string | null, e164?: any | null } | null }> } };


export const AuditLogsDocument = gql`
    query AuditLogs($offset: Int!, $limit: Int!, $domainId: Int, $numberOrActorFilter: String, $sortBy: [AuditLogsSortBy!]) {
  auditLogs(
    offset: $offset
    limit: $limit
    domainId: $domainId
    sortBy: $sortBy
    numberOrActorFilter: $numberOrActorFilter
  ) {
    items {
      id
      actor
      category
      change
      timestamp
      details
      domain {
        id
        name
      }
      number {
        id
        shortNumber
        e164
      }
      relatedNumber {
        id
        shortNumber
        e164
      }
    }
    totalCount
  }
}
    `;

/**
 * __useAuditLogsQuery__
 *
 * To run a query within a React component, call `useAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuditLogsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      domainId: // value for 'domainId'
 *      numberOrActorFilter: // value for 'numberOrActorFilter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables> & ({ variables: AuditLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
      }
export function useAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export function useAuditLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AuditLogsQuery, AuditLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AuditLogsQuery, AuditLogsQueryVariables>(AuditLogsDocument, options);
        }
export type AuditLogsQueryHookResult = ReturnType<typeof useAuditLogsQuery>;
export type AuditLogsLazyQueryHookResult = ReturnType<typeof useAuditLogsLazyQuery>;
export type AuditLogsSuspenseQueryHookResult = ReturnType<typeof useAuditLogsSuspenseQuery>;
export type AuditLogsQueryResult = Apollo.QueryResult<AuditLogsQuery, AuditLogsQueryVariables>;